import { type Board, type Clip } from '@air/api/types';
import { formatBytes } from '@air/utilities';

import { LIST_VIEW_BLANK_CELL, type ListViewColumnField } from '~/constants/listViewColumns';
import { formatListViewDate } from '~/utils/formatListViewDate';

export type ListViewRowInfo = Record<ListViewColumnField, string>;

const withBlankFallback = (value: string | undefined) => value ?? LIST_VIEW_BLANK_CELL;

export const getBoardListViewRowInfo = (board: Board): ListViewRowInfo => ({
  boardCount: LIST_VIEW_BLANK_CELL,
  dateCreated: withBlankFallback(formatListViewDate(board.createdAt)),
  dateModified: withBlankFallback(formatListViewDate(board.updatedAt)),
  dateTaken: LIST_VIEW_BLANK_CELL,
  dateUploaded: withBlankFallback(formatListViewDate(board.createdAt, true)),
  ext: LIST_VIEW_BLANK_CELL,
  openCommentCount: LIST_VIEW_BLANK_CELL,
  resolution: LIST_VIEW_BLANK_CELL,
  size: LIST_VIEW_BLANK_CELL,
  tagCount: LIST_VIEW_BLANK_CELL,
  type: LIST_VIEW_BLANK_CELL,
  uploadedBy: LIST_VIEW_BLANK_CELL,
});

export const getClipListViewRowInfo = (clip: Clip): ListViewRowInfo => ({
  boardCount: `${clip.boardCount ?? 0}`,
  dateCreated: withBlankFallback(formatListViewDate(clip.recordedAt)),
  dateModified: withBlankFallback(formatListViewDate(clip.updatedAt)),
  dateTaken: withBlankFallback(formatListViewDate(clip.dateTaken)),
  dateUploaded: withBlankFallback(formatListViewDate(clip.createdAt, true)),
  ext: clip.ext || LIST_VIEW_BLANK_CELL,
  openCommentCount: `${clip.openDiscussionCount || 0}`,
  resolution: clip.width && clip.height ? `${clip.width} x ${clip.height}` : LIST_VIEW_BLANK_CELL,
  size: clip.size ? formatBytes(clip.size) : LIST_VIEW_BLANK_CELL,
  tagCount: `${clip.tags?.length ?? 0}`,
  type: clip.type === 'nonMedia' ? 'file' : clip.type,
  uploadedBy: clip.ownerName || LIST_VIEW_BLANK_CELL,
});
